export class GetAllFilter {
  pageIndex: number;
  take: number;

  filterExpression: string;
  filterColumn: string;

  sortColumn: string;
  sortDirection: SortDirection;
}

export enum SortDirection {
  ASC = 0,
  DESC = 1,
}
